export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8163.3655c518.jpg";